import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, TS_Input } from '@nu-art/thunderstorm-frontend';
import { Component_SearchAddOn } from '../../components/Component_SearchAddOn.js';
import { AddOn_SearchTerms } from './types.js';
import './Component_AddOn_SearchTerms.scss';
import { TS_Icons } from '@nu-art/ts-styles';
export class Component_AddOn_SearchTerms extends Component_SearchAddOn {
    addOn = AddOn_SearchTerms;
    deriveStateFromProps(nextProps, state) {
        state.placeholder = nextProps.placeholder;
        return state;
    }
    render() {
        return _jsxs(LL_H_C, { className: 'search-add-on__search-terms', children: [_jsx(TS_Input, { type: 'text', value: this.state.value, placeholder: this.state.placeholder, onChange: val => this.setValue(val.trimStart()), innerRef: this.props.inputRef }), _jsx(TS_Icons.Search.component, {})] });
    }
}
//# sourceMappingURL=Component_AddOn_SearchTerms.js.map